import { AbstractStore } from '@deqo/foundation';
import { injectable } from 'inversify';
import { invokeLater, uuid } from '../../CodesThatsGottaGoSomewhereElse';
import { PopupDefinition, PopupInstance, PopupResult } from './Popup';

export interface PopupState {
    current?: PopupInstance;
}

@injectable()
export class PopupManager extends AbstractStore<PopupState> {

    protected state: PopupState = {};

    public get current() {
        return this.state.current;
    }

    constructor() {
        super();
    }

    public invoke(modal: PopupDefinition): Promise<PopupResult> {
        this.dismiss();
        return new Promise((rs) => {
            const current = this.createInstance(modal, (actioned, data) => {
                invokeLater(0, () => rs({ actioned, data }));
                this.updateState({ current: null });
            });
            this.updateState({ current });
        });
    }

    public dismiss(): void {
        if (this.current) {
            this.current.dismiss();
        }
    }

    public waitForNoPopup() {
        return new Promise<void>((rs) => {
            if (this.current) {
                const cancel = this.observe(next => {
                    if (!next.current) {
                        cancel();
                        rs();
                    }
                });
                this.burden(cancel);
            }
            else {
                rs();
            }
        });
    }

    private createInstance(def: PopupDefinition, callback: (actioned: boolean, data?: any) => void) {
        return {
            id: uuid(),
            ui: def.ui,
            fullscreen: !!def.fullscreen,
            droppable: !!def.droppable,
            fade: def.fade !== false,
            args: def.args ?? {},
            action: data => callback(true, data),
            dismiss: () => callback(false),
        };
    }
}
